import React, { useState } from "react";

import ConfirmationBox from "../../../components/common/ConfirmationBox";

import { Button, Card, Col, Row } from "antd";

import { MdOutlineRemoveCircle } from "react-icons/md";
import { RiUpload2Fill } from "react-icons/ri";
import { letters } from "./data";

import "./Letters.css";

function Letters() {
  const [allLetters, setAllLetters] = useState(letters);
  const [showAll, setShowAll] = useState(false);
  const [letterId, setLetterId] = useState(0);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const limit = 4;

  const handleDelete = (id) => {
    setIsConfirmationBoxOpen(true);
    setLetterId(id);
  };

  const deleteLetter = (id) => {
    const newArr = allLetters.filter((item) => {
      return item.id !== id;
    });
    setAllLetters(newArr);
    setIsConfirmationBoxOpen(false);
  };

  return (
    <Row className="letters">
      <Col span={24}>
        <Card title="Letters">
          {showAll ? (
            <>
              {allLetters.map((item, index) => {
                return (
                  <Row
                    className="letter-row"
                    justify="space-between"
                    key={index}
                  >
                    <Col>
                      <span className="onclick-text">{item.letterName}</span>
                    </Col>
                    <Col>
                      <div className="right-side">
                        <div>
                          <span>Created on: {item.createdOn} </span>
                        </div>
                        <div className="preview-container">
                          <RiUpload2Fill />
                          <span className="onclick-text">Preview</span>
                        </div>
                        <MdOutlineRemoveCircle
                          size={18}
                          className="delete-btn"
                        />
                      </div>
                    </Col>
                  </Row>
                );
              })}
            </>
          ) : (
            <>
              {allLetters.slice(0, limit).map((item, index) => (
                <Row className="letter-row" justify="space-between" key={index}>
                  <Col>
                    <span className="onclick-text">{item.letterName}</span>
                  </Col>
                  <Col>
                    <div className="right-side">
                      <div>
                        <span>Created on: {item.createdOn} </span>
                      </div>
                      <div className="preview-container">
                        <RiUpload2Fill />
                        <span className="onclick-text">Preview</span>
                      </div>
                      <MdOutlineRemoveCircle
                        size={18}
                        className="delete-btn"
                        onClick={() => handleDelete(item.id)}
                      />
                    </div>
                  </Col>
                </Row>
              ))}
            </>
          )}

          {showAll ? null : (
            <Row justify="end">
              <Col>
                <span className="onclick-text" onClick={() => setShowAll(true)}>
                  Show remaining {allLetters.length - limit}{" "}
                  {allLetters.length - limit > 1 ? "Letters" : "Letter"}
                </span>
              </Col>
            </Row>
          )}
        </Card>
      </Col>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Please Confirm</h2>
          <p>
            Would you like to delete only this letter or all letters in this
            batch?
          </p>
          <div className="action-buttons">
            <Button type="primary" onClick={() => deleteLetter(letterId)}>
              Only this letter
            </Button>
            <button className="cancel-btn">
              All {letters.length} letters in this batch
            </button>
            <button className="cancel-btn">Cancel</button>
          </div>
        </ConfirmationBox>
      ) : null}
    </Row>
  );
}

export default Letters;
